import { useTranslation } from '../../core/hooks/use-translation';
import { partners } from '../../site/partners';

/** The developers whose buildings the company arranges mortgages on. */
export function PartnersSection() {
    const { t } = useTranslation();

    return (
        <section className="section section-alt partners-section" id="partners">
            <div className="container">
                <div className="section-header centered">
                    <span className="section-label">{t('site.partners.label')}</span>
                    <h2 className="section-title">{t('site.partners.title')}</h2>
                </div>
                <p className="partners-intro">{t('site.partners.intro')}</p>

                <div className="partners-grid">
                    {partners.map((partner) => (
                        <div className="partner-card" key={partner.name}>
                            <img src={partner.logo} alt={partner.name} className="partner-logo" />
                            <div className="partner-name">{partner.name}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
